"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextWrapper = exports.List = exports.Container = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SubMenu = require("../SubMenu.style");
const TextWrapper = exports.TextWrapper = _styledComponents.default.div.withConfig({
  displayName: "SubMenuWithMultiColumnsstyle__TextWrapper",
  componentId: "sc-1esaq9n-0"
})(["", ";div{text-transform:uppercase;color:", ";font-weight:600;}"], _SubMenu.ITEM_PADDING, _uiKit.theme.colours.NEUTRALS_2);
const Container = exports.Container = _styledComponents.default.li.withConfig({
  displayName: "SubMenuWithMultiColumnsstyle__Container",
  componentId: "sc-1esaq9n-1"
})([":not(:last-of-type){margin-right:5px;}:last-of-type{margin-left:5px;}"]);
const List = exports.List = _styledComponents.default.ul.withConfig({
  displayName: "SubMenuWithMultiColumnsstyle__List",
  componentId: "sc-1esaq9n-2"
})(["padding:0;"]);